export default (YTDMonthlyAsOfDate) => ({
    POMIX: `<B>Performance Linked Benchmark:</B> reflects the performance of the Dow Jones Wilshire 5000 Composite 
    Index from 1-30-98 to 3-31-07 and the performance of the S&P Total Market Index from 4/1/07 to 
    ${YTDMonthlyAsOfDate}.
    Effective 4/1/07, the fund changed its benchmark from the Dow Jones Wilshire 5000 
    Composite Index to the S&P Total Market Index.`,
    PEXMX: `<B>Performance Linked Benchmark:</B> reflects the performance of the Dow Jones Wilshire 4500 
    Completion Index from 1/30/98 to 3/31/07 and the performance of the S&P Completion Index from 4/1/07 to 
    ${YTDMonthlyAsOfDate}.
    Effective 4/1/07, the fund changed its benchmark from the Dow Jones Wilshire 4500 
    Completion Index to the S&P Completion Index.`,
    PRSIX: `<B>Combined Index Portfolio</B> is a blended index portfolio 
    consisting of 40% stocks (32%-28% Russell 3000 Index, 8%-12% MSCI All 
    Country World ex-U.S. Index), 40% bonds (Barclays Capital U.S. Aggregate Index), 
    and 20% money market securities (Citigroup 3-Month Treasury Bill Index). `,
    TRSGX: `<B>Combined Index Portfolio</B> is a blended index 
    portfolio consisting of 80% stocks (64%-56% Russell 3000 Index, 16%-24% 
    MSCI All Country World ex-U.S. Index) and 20% bonds (Barclays Capital U.S. Aggregate Index).`,
    TRPBX: `<B>Combined Index Portfolio</B> is a blended 
    index portfolio consisting of 60% stocks (48%-42% Russell 3000 Index, 
    12%-18% MSCI All Country World ex-U.S. Index), 30% bonds 
    (Barclays Capital U.S. Aggregate Index), and 10% money market 
    securities (Citigroup 3-Month Treasury Bill Index).`,
    TRLAX: `*Retirement Income 2020 Fund requires a $25,000 Minimum Investment`,
    BLENDED_PORTFOLIO: `<B>Retirement Funds Combined Index Portfolios </B>are blended index portfolios used to 
    evaluate the performance of the Retirement Funds. The composition of each fund's 
    benchmark adjusts on a quarterly basis to reflect the fund's strategic neutral target 
    allocation for each asset class, which is predetermined and changes over time. 
    The Retirement Balanced Fund's combined index portfolio does not change. The most recent mix of 
    underlying indexes can be found in the Performance section of each fund's quarterly commentary, 
    available by accessing the Management/Commentary tab above.`
});
